import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddDesiredType.css";
import { createDesired } from "../../../../services/DesiredType/DesiredType.service";
import { toast } from "react-toastify";

const AddDesiredType: React.FC = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Desired Type name is required");
      return;
    }

    try {
      await createDesired({
        name: name.trim(),
        description: description.trim(),
      });
      toast.success("Desired Type saved successfully");
      navigate("/desired-type/list");
    } catch (error) {
      console.error("Error creating desired:", error);
      toast.error("Failed to create Desired Type. Please try again.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h2>Add Desired Type</h2>
          <span className="close-btn" onClick={() => navigate(-1)}>
            ✕
          </span>
        </div>

        <p className="subtitle">
          Enter the details for the desired type.
        </p>

        <form onSubmit={handleSubmit}>
          <label>Desired Name *</label>
          <input
            type="text"
            placeholder="Enter desired type name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <label>Description</label>
          <input
            type="text"
            placeholder="Enter description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="submit" className="add-btn">
              Save Desired Type
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDesiredType;
